module.exports = __webpack_public_path__ + "img/illusCorona.b82a8b41.jpg";